import React from "react"
import { Link } from "gatsby"
import PageLayout from "../../components/PageLayout"
import Footer from "../../components/Footer"
import './reportTemplate.css'
import { Accordion, Col, Container, Row, Table } from "react-bootstrap"

const SECTION_TITLE_1='Contact & Program Identification'
const SECTION_TITLE_2='Focus of Assessment'
const SECTION_TITLE_3='Initial Round of Assessment'
const SECTION_TITLE_4='Analysis of Initial Round of Assessment Data'
const SECTION_TITLE_5='Changes Implemented'
const SECTION_TITLE_6='Second Round of Assessment'
const SECTION_TITLE_7='Analysis of Second Round of Assessment Data'
const SECTION_TITLE_8='Program Summary'

const PHASE_ONE=1
const PHASE_TWO=2
const CURRENT_PHASE=PHASE_ONE

function ChangeList(props) {
    let slo = props.slo
    return (
        <ul>
            {slo.apprachToolChanges === true &&
                <li>Change in teaching approach</li>
            }
            {slo.facultyDevelopment === true &&
                <li>Faculty training/development</li>
            }
            {slo.courseContentChanges === true &&
                <li>Change in course content</li>
            }
            {slo.courseSequencePrerequisiteChanges === true &&
                <li>Change in course sequence/prerequisites</li>
            }
            {slo.gradingMethodologyChanges === true &&
                <li>Grading Methodology Changes</li>
            }
            {slo.assignmentRevisionChanges === true &&
                <li>Assignment Revision</li>
            }
            {slo.budgetaryReallocationChanges === true &&
                <li>Budgetary Reaalocation</li>
            }
            {slo.otherChanges === true &&
                <li>Other</li>
            }
        </ul>
    )
}

function ReviewYear(props) {
    let reviewYear = props.reviewYear
    // TODO: Maybe the phase number should be passed in instead.
    //       We can operate on 1 and 2 and only show review year
    //       if neither 1 or 2.
    let isPhaseOne = props.isPhaseOne
    return (
        <div>
            {reviewYear}
            &nbsp;-&nbsp;
            <strong>
            { isPhaseOne 
                ?
                'Midpoint Report'
                :
                ''
            }
            </strong>
        </div>
    )
}

const reportTemplateV2 = props => {
    const report = props.pageContext;
    let indexUrl = "/v2/" + report.yearAssessed

    let step1Data = report.step1Data
    let step2Data = report.step2Data
    // Step 3 Data not used in report
    //let step3Data = report.step3Data
    let step4Data = report.step4Data
    let step5Data = report.step5Data
    // Step 6 Data not used in report
    //let step6Data = report.step6Data
    let step7Data = report.step7Data

    let phaseOneTabs=["1", "2", "3", "4", "5"]
    let phaseTwoTabs=["6", "7", "8"]

    let defaultTabs = []
    if (CURRENT_PHASE === PHASE_ONE) {
        defaultTabs = phaseOneTabs
    } else if (CURRENT_PHASE === PHASE_TWO) {
        defaultTabs = phaseTwoTabs
    }

    const sortOutcomes = (unsortedOutcomes) => {
        if (unsortedOutcomes == null || !Array.isArray(unsortedOutcomes)) {
            return unsortedOutcomes
        }
        
        return unsortedOutcomes.sort((a,b) => a.sloId > b.sloId ? 1 : ((a.sloId < b.sloId) ? -1 : 0))
    }

    return (
        <PageLayout>
            <div className="content">
                <div className="row row-cols-1 row-cols-md-1">
                    <h1 className="p-5 text-center">
                        Archived Assessment Report
                    </h1>
                </div>

                <Accordion defaultActiveKey={defaultTabs} alwaysOpen>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>1. {SECTION_TITLE_1}</Accordion.Header>
                        <Accordion.Body>
                            <Table striped>
                                <tbody>
                                    <tr>
                                        <td>Program</td>
                                        <td>{report.programName}</td>
                                    </tr>
                                    <tr>
                                        <td>Assessment Reporter</td>
                                        <td>{report.createdBy}</td>
                                    </tr>
                                    <tr>
                                        <td>Theme</td>
                                        <td>{report.themeText}</td>
                                    </tr>
                                    <tr>
                                        <td>Review Year</td>
                                        <td>
                                            <ReviewYear reviewYear={report.yearAssessed} isPhaseOne={true} />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                        <Accordion.Header>2. {SECTION_TITLE_2}</Accordion.Header>
                        <Accordion.Body>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Learning Outcome (or Gen Ed Essential Skill)</th>
                                        <th>Focus Area</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { step1Data &&
                                      sortOutcomes(step1Data.learningOutcomes).map((lo,key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{lo.sloText}</td>
                                                <td>{lo.focusQuestion}</td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </Table>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="3">
                        <Accordion.Header>3. {SECTION_TITLE_3}</Accordion.Header>
                        <Accordion.Body>
                            <Table>
                                <thead>
                                    <tr>
                                    <th>Learning Outcome (or Gen Ed Essential Skill)</th>
                                    <th>Description of Assessment Tool</th>
                                    <th>Population or Courses Assessed</th>
                                    <th>Hypothetical Analysis/Target</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { step2Data &&
                                      sortOutcomes(step2Data.learningOutcomes).map((lo, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{lo.sloText}</td>
                                                <td>{lo.toolDescription}</td>
                                                <td>{lo.coursesAssessed}</td>
                                                <td>{lo.hypotheticalAnalysis}</td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </Table>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="4">
                        <Accordion.Header>4. {SECTION_TITLE_4}</Accordion.Header>
                        <Accordion.Body>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Learning Outcome (or Gen Ed Essential Skill)</th>
                                        <th>Summary of Results</th>
                                        <th>Reflection on Focus Area</th>
                                        <th>Intepretation of Results</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { step4Data &&
                                      sortOutcomes(step4Data.learningOutcomes).map((lo, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{lo.sloText}</td>
                                                <td>{lo.resultsSummary}</td>
                                                <td>{lo.focusAreaReflection}</td>
                                                <td>{lo.interpretationOfResults}</td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </Table>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="5">
                        <Accordion.Header>5. {SECTION_TITLE_5}</Accordion.Header>
                        <Accordion.Body>
                            { step5Data &&
                              sortOutcomes(step5Data.learningOutcomes).map((lo, key) => {
                                return (
                                    <Table striped key={key}>
                                        <thead>
                                            <tr>
                                                <th colSpan="2" style={{'backgroundColor':'dddddd'}}>
                                                    {lo.sloText}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Describe the change that was implemented.</td>
                                                <td>{lo.changesPlanned}</td>
                                            </tr>
                                            <tr>
                                                <td>Type of Change</td>
                                                <td>
                                                    <ChangeList slo={lo} />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Change in Assessment Approach or Tools?</td>
                                                <td>{lo.changeInApproach}</td>
                                            </tr>
                                            <tr>
                                                <td>What data motivated the change?</td>
                                                <td>{lo.dataMotivation}</td>
                                            </tr>
                                            <tr>
                                                <td>Hypothesis about the effect the change will have?</td>
                                                <td>{lo.changeHypothesis}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                )
                            })
                            }
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="6">
                        <Accordion.Header>6. {SECTION_TITLE_6}</Accordion.Header>
                        <Accordion.Body>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Learning Outcome (or Gen Ed Essential Skill)</th>
                                        <th>Description of Assessment Tool</th>
                                        <th>Population of Courses Assessed</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { step5Data &&
                                      sortOutcomes(step5Data.learningOutcomes).map((lo, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{lo.sloText}</td>
                                                <td>{lo.secondRoundToolDescription}</td>
                                                <td>{lo.secondRoundCoursesAssessed}</td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </Table>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="7">
                        <Accordion.Header>7. {SECTION_TITLE_7}</Accordion.Header>
                        <Accordion.Body>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Learning Outcome (or Gen Ed Essential Skill)</th>
                                        <th>Summary of Second<br/>Round Results</th>
                                        <th>Intepretation of Results, <br/>Pre- and Post-Change</th>
                                        <th>Follow up questions, <br/>possible next steps</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { step7Data &&
                                      sortOutcomes(step7Data.learningOutcomes).map((lo,key) => {
                                        return (
                                            <tr key={key}>
                                                <td>{lo.sloText}</td>
                                                <td>{lo.summaryOfResults}</td>
                                                <td>{lo.intepretationOfBothRounds}</td>
                                                <td>{lo.followUpAndNextSteps}</td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </Table>
                        </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="8">
                        <Accordion.Header>8. {SECTION_TITLE_8}</Accordion.Header>
                        <Accordion.Body>
                            <Container>
                                <Row className="p-3">
                                    <Col>
                                        Describe any change in student achievement observed as part of this assessment process,
                                        and what led to those changes.
                                        <br /><br />
                                        <div className="p-3 bg-light border">
                                            {step7Data?.finalReflection.studentAchievementChanges}
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="p-3">
                                    <Col>
                                        Describe long-term changes in the program(s) that the assessment process led to, and what
                                        motivated those changes?
                                        <br /><br />
                                        <div className="p-3 bg-light border">
                                            {step7Data?.finalReflection.longTermProgramChanges}
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="p-3">
                                    <Col>
                                        What did you learn about the teaching and learning of "Practicing Community" in your programs?
                                        <br /><br />
                                        <div className="p-3 bg-light border">
                                            {step7Data?.finalReflection.themeLessonsLearned}
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="p-3">
                                    <Col>
                                        Describe any external factors affecting the program or affecting assessment of the program.
                                        <br /><br />
                                        <div className="p-3 bg-light border">
                                            {step7Data?.finalReflection.externalFactors}
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </div>

            <div className="col p-3 text-center">
                <Link 
                    to={indexUrl}
                    className="btn btn-primary pull-right"
                    role="button">
                    Back
                </Link>
            </div>

            <Footer />
        </PageLayout>
    )
}

export default reportTemplateV2